module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: ({
        precision: _vm.precision,
        decimal: _vm.decimal,
        thousands: _vm.thousands,
        prefix: _vm.prefix,
        suffix: _vm.suffix
      }),
      expression: "{precision, decimal, thousands, prefix, suffix}"
    }],
    staticClass: "v-money",
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "change": _vm.change,
      "blur": function($event) {
        return _vm.$emit('blur')
      },
      "focus": function($event) {
        return _vm.$emit('focus')
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26c9d4a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/3rd/v-money/component.vue
// module id = 901
// module chunks = 2